module.exports = __webpack_public_path__ + "static/media/emoji-neutral-face.6ffdbf71.png";